import React from 'react';
import { Transfer as AntTransfer } from 'antd';
import { ChevronLeft, ChevronRight } from '@nackle/origami-icons';

/**
 * A transfer component
 *
 * {@link https://ant.design/components/transfer#api}
 *
 * @param {Object} props - the transsfer props
 * @param {string} [props.searchPlaceholder] - the placeholder text for hte search
 * @returns {React.ReactElement}
**/
const Transfer = ( { ...props } ) => {
    const { searchPlaceholder } = props;

    return (
        <AntTransfer
            locale={ { searchPlaceholder: searchPlaceholder } }
            operations={ [ ChevronLeft, ChevronRight ] }
            { ...props }
        />
    );
};

export { Transfer };
